import React, { useState, useEffect } from 'react';
import {
    Plus, Eye, MapPin, User, Calendar, IndianRupee, FileText, X, Users, no_of_home, TreePine, Edit, Save, Check, Trash2, ArrowLeft, Download,    // Add this
    Layers,
    ZoomIn, ZoomOut, ChevronLeft, ChevronRight,
    Building,
    Info,
    CreditCard,
    Percent,
    Shield, DollarSign, Upload, Image, FileType
} from 'lucide-react';

import AddOwner from './AddOwner';
import EditOwner from './EditOwner';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import apiService from '../config';
import { useLanguage } from "../StoreContext/LanguageContext";

const ViewMeasurementList = ({ onFileChange, landAcquisitionId, onBack, initialMeasurementData = null,
    onDataUpdate = null, setSubComponent, }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [showconfirm, setShowConfirm] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        type: 'success'
    });
    const { language, translations } = useLanguage();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });

    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);

        // Don't auto-hide success messages so user can see them
        if (type !== 'success') {
            setTimeout(() => setShowAlertModal(false), 5000);
        }
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [measurementId, setMeasurementId] = useState(null);
    const [measurementData, setMeasurementData] = useState(null);
    const [landAcquisitionData, setLandAcquisitionData] = useState(null);
    const [ownersData, setOwnersData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedOwner, setSelectedOwner] = useState(null);

    // Data states
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [selectedOwnerData, setSelectedOwnerData] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightSummary, setHighlightSummary] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [existingFiles, setExistingFiles] = useState([]);
    const [viewMode, setViewMode] = useState('list');
    const [selectedFilePreview, setSelectedFilePreview] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [viewedOwner, setViewedOwner] = useState(null);
    const [showImageViewer, setShowImageViewer] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [owners, setOwners] = useState([]);
    const [landAcquisition, setLandAcquisition] = useState(null);
    const [selectedOwnerIndex, setSelectedOwnerIndex] = useState(0);
    const [selectedOwnerInDetails, setSelectedOwnerInDetails] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [solatiumPercentage, setSolatiumPercentage] = useState(30);
    const [totalPercentage, setTotalPercentage] = useState(0);
    const [showAddOwner, setShowAddOwner] = useState(false);
    const [showEditOwner, setShowEditOwner] = useState(false);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [uploadedFileNames, setUploadedFileNames] = useState([]);

    const USER_ROLES = {
        SURVEYOR: 7,
        LAO: 3,
        DSLR: 15,
        AGENCY: 21
    };
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const userRole = Number(userData?.user_role) || 0;
    const [identityProofs, setIdentityProofs] = useState({
        aadhaarNumber: '',
        panNumber: '',
        documents: [] // Array to store multiple 7/12 document images
    });
    const handleCloseAddOwner = () => {
        setShowAddOwner(false);
        // Add any navigation logic here if needed
        // For example: navigate('/viewmeasurement') or window.location.reload()
    };
    const handleCloseEditOwner = () => {
        setShowEditOwner(false);
        // Add any navigation logic here if needed
        // For example: navigate('/viewmeasurement') or window.location.reload()
    };
    const handleDeleteRecord = async (owner) => {
        if (!owner.land_owner_id) {
            showAlert('Invalid record ID', 'Cannot delete record without valid ID', 'error');
            return;
        }

        // Show confirmation dialog
        showConfirm(
            'Delete Record',
            `Are you sure you want to delete the record for "${owner.owner_name}"? This action cannot be undone.`,
            async () => {
                try {
                    setLoading(true);

                    // Soft delete by setting is_active to 0
                    const updatePayload = {
                        is_active: 0
                    };

                    // Call patch update API with is_active: 0
                    const response = await apiService.patchUpdateMeasurement(
                        owner.land_owner_id,
                        updatePayload
                    );

                    if (response.status === 200) {
                        showAlert('Success', 'Record deleted successfully!', 'success');

                        // Refresh the measurements list
                        await refreshMeasurementData();
                    } else {
                        showAlert('Error', 'Failed to delete record. Please try again.', 'error');
                    }
                } catch (error) {
                    console.error('Error deleting record:', error);
                    showAlert('Error', 'Error occurred while deleting record. Please try again.', 'error');
                } finally {
                    setLoading(false);
                }
            },
            null,
            'danger'
        );
    };

    const [newOwner, setNewOwner] = useState({
        owner_name: '',
        contact_number: '',
        email: '', owner_type: '',
        owner_address: '', aadhaar_number: '', pan_number: '', bank_name: '',
        branch_name: '', account_number: '', ifsc_code: '', account_holder_name: '',
        survey_no: '', land_area: '', land_category: '', land_use: '', land_value_rate: '',
        no_of_structure: '', no_of_tree: '', no_of_water_body: '', no_of_other_asset: '', no_of_crop: ''

    });
    const [editFormData, setEditFormData] = useState({
        project_id: '',
        village_id: '',
        survey_no: '',
        owner_aqr_area: '',
        area_unit_id: 'ACRE',
        landholder_name: '',
        survey_type: 'Revenue',
        irrigable_type: '',
        irrigable_area: '',
        non_irrigable_area: '',
        owner_total_area: '',
        owner_aqr_area: '',
        akoom: '',
        dist_no: '',
        tehsil_no: '',
        // Add new editable fields
        no_of_tree: '',
        latitude: '',
        longitude: '',
        no_of_home: '',
        no_of_other_asset: '',
        no_of_water_body: '',
        no_of_borewell: '',
        no_of_pipeline: '',
        no_of_wirefencing: '',
        no_of_tinshed: '',
        remarks: '',
        // Owner details
        owner_name: '',
        owner_type: '',
        owner_contact: '',
        owner_email: '',
        owner_address: '',
        bank_name: '',
        branch_name: '',
        account_number: '',
        ifsc_code: '',
        account_holder_name: '',
        aadhaar_number: '',
        pan_number: ''
    });
    // const handleFileUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         setUploadedFile(file);
    //     }
    // };

    //viewImage
    const imageFiles = uploadedFiles.filter(file => file.type.startsWith('image/'));

    const openImageViewer = (index = 0) => {
        setCurrentImageIndex(index);
        setShowImageViewer(true);
        setZoomLevel(1);
    };

    const closeImageViewer = () => {
        setShowImageViewer(false);
        setZoomLevel(1);
    };

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % imageFiles.length);
        setZoomLevel(1);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + imageFiles.length) % imageFiles.length);
        setZoomLevel(1);
    };

    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.25, 3));
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
    };

    const downloadImage = (file) => {
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    // Solution 1: Hide elements with CSS class during PDF generation
    const handleDownloadPDF = async () => {
        setShowConfirm(false);
        try {
            const tableElement = document.querySelector('.min-w-full');

            if (!tableElement) {
                console.error('Table element not found');
                return;
            }

            // Hide edit buttons and actions before capturing
            const editButtons = tableElement.querySelectorAll('.edit-btn, .action-btn, .btn-edit, [class*="edit"], [class*="action"]');
            const actionColumns = tableElement.querySelectorAll('th:last-child, td:last-child'); // Assuming action column is last

            // Store original display values
            const originalStyles = [];
            [...editButtons, ...actionColumns].forEach((element, index) => {
                originalStyles[index] = element.style.display;
                element.style.display = 'none';
            });

            // Create canvas from table
            const canvas = await html2canvas(tableElement, {
                scale: 2,
                scrollY: -window.scrollY,
                useCORS: true,
            });

            // Restore original display values
            [...editButtons, ...actionColumns].forEach((element, index) => {
                element.style.display = originalStyles[index];
            });

            // Create PDF
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('l', 'mm', 'a4');
            const imgWidth = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`Measurement_${landAcquisitionData?.LandAcquisition_id || 'report'}.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            setError('Failed to generate PDF. Please try again.');
        }
    };



    // Solution 3: Clone table and remove unwanted elements
    const handleDownloadPDFClone = async () => {
        setShowConfirm(false);
        try {
            const originalTable = document.querySelector('.min-w-full');

            if (!originalTable) {
                console.error('Table element not found');
                return;
            }

            // Clone the table
            const tableClone = originalTable.cloneNode(true);

            // Remove edit buttons and action columns from clone
            const editButtons = tableClone.querySelectorAll('.edit-btn, .action-btn, .btn-edit, [class*="edit"], [class*="action"]');
            const actionColumns = tableClone.querySelectorAll('th:last-child, td:last-child');

            // Remove unwanted elements
            editButtons.forEach(btn => btn.remove());
            actionColumns.forEach(col => col.remove());

            // Create a temporary container
            const tempContainer = document.createElement('div');
            tempContainer.style.position = 'absolute';
            tempContainer.style.left = '-9999px';
            tempContainer.appendChild(tableClone);
            document.body.appendChild(tempContainer);

            // Create canvas from cloned table
            const canvas = await html2canvas(tableClone, {
                scale: 2,
                scrollY: -window.scrollY,
                useCORS: true,
            });

            // Remove temporary container
            document.body.removeChild(tempContainer);

            // Create PDF
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('l', 'mm', 'a4');
            const imgWidth = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`Measurement_${landAcquisitionData?.LandAcquisition_id || 'report'}.pdf`);

        } catch (error) {
            console.error('Error generating PDF:', error);
            setError('Failed to generate PDF. Please try again.');
        }
    };


    // Solution 4: Conditional rendering approach (if you can modify the table component)
    // Add this CSS to your stylesheet
    /*
    .pdf-generating .edit-btn,
    .pdf-generating .action-btn,
    .pdf-generating .btn-edit,
    .pdf-generating [data-action="edit"],
    .pdf-generating [data-action="delete"],
    .pdf-generating .action-column {
        display: none !important;
    }
    */

    // In your table component, add data attributes or classes to action elements:
    // <button className="edit-btn" data-action="edit">Edit</button>
    // <td className="action-column">...</td>

    const handleViewDocument = () => {
        if (uploadedFile) {
            const url = URL.createObjectURL(uploadedFile);
            window.open(url, '_blank');
        }
    };

    // const refreshMeasurementData = async () => {
    //     try {
    //         const response = await apiService.getMeasurementByLandId(landAcquisitionId);
    //         if (response && response.data) {
    //             setOwnersData(response.data);
    //         }
    //     } catch (error) {
    //         console.error('Error refreshing data:', error);
    //     }
    // };

    const refreshMeasurementData = async () => {
        const response = await apiService.getMeasurementByLandId(landAcquisitionId);
        setOwners(response.data);
        setLandAcquisition(response.landAcquisition);
        fetchMeasurementData();
    };

    // useEffect(() => {
    //     if (landAcquisitionId) {
    //         console.log('🔄 Reloading measurement data for:', landAcquisitionId);
    //         refreshMeasurementData();
    //     }
    // }, [landAcquisitionId]);


    // Callback function to handle when owner is added
    const handleOwnerAdded = (result) => {
        if (result.status === 200) {
            // Refresh the measurement data to show the new owner
            refreshMeasurementData();

            // Show success message
            setSuccessMessage('Occupant added successfully!');

            // Clear success message after 3 seconds
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        }
    };

    // Callback function to handle when owner is added
    const handleOwnerEdited = (result) => {
        if (result.status === 200) {
            // Refresh the measurement data to show the new owner
            refreshMeasurementData();

            // Show success message
            setSuccessMessage('Occupant added successfully!');

            // Clear success message after 3 seconds
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        }
    };

    const handleIdentityProofChange = (field, value) => {
        setIdentityProofs(prev => ({
            ...prev,
            [field]: value
        }));

        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    useEffect(() => {
        if (measurementId) {
            loadExistingFiles();
        }
    }, [measurementId]);

    const loadExistingFiles = async () => {
        try {
            setLoading(true);

            const response = await apiService.getMeasurementByOwnerID(measurementId);

            if (response.status === 200 && response.data.length > 0) {
                const data = response.data[0]; // assuming response.data is an array
                const files = [];

                Object.entries(data).forEach(([key, value]) => {
                    if (
                        (key.startsWith('image_') || key.startsWith('document_')) &&
                        value &&
                        key !== 'undefined'
                    ) {
                        files.push({
                            id: key,
                            name: key.replace(/_/g, ' ').toUpperCase(),
                            url: value,
                            type: getFileTypeFromUrl(value)
                        });
                    }
                });


                setExistingFiles(files); // ⬅️ this sets the state to display in UI
            }
        } catch (error) {
            console.error('Error loading existing files:', error);
        } finally {
            setLoading(false);
        }
    };


    const getFileTypeFromUrl = (url) => {
        const extension = url.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
        if (['pdf'].includes(extension)) return 'pdf';
        if (['doc', 'docx'].includes(extension)) return 'document';
        return 'file';
    };

    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);

        if (files.length === 0) return;

        // Validate files
        const maxSize = 10 * 1024 * 1024; // 10MB per file
        const maxFiles = 20; // Maximum 20 files total
        const allowedTypes = [
            'application/pdf',
            'image/jpeg',
            'image/jpg',
            'image/png',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        // Check if adding these files would exceed the limit
        if (uploadedFiles.length + files.length > maxFiles) {
            showAlert(`Maximum ${maxFiles} files allowed. You can select ${maxFiles - uploadedFiles.length} more file(s).`);
            return;
        }

        const validFiles = [];
        const errors = [];

        files.forEach(file => {
            if (file.size > maxSize) {
                errors.push(`${file.name} is too large (max 10MB)`);
            } else if (!allowedTypes.includes(file.type) && !file.type.startsWith('image/')) {
                errors.push(`${file.name} is not a supported file type`);
            } else {
                validFiles.push(file);
            }
        });

        if (errors.length > 0) {
            showAlert('Some files were not added:\n' + errors.join('\n'));
        }

        if (validFiles.length > 0) {
            // Add to existing files instead of replacing
            setUploadedFiles(prev => [...prev, ...validFiles]);

            // Show success message for multiple files
            const imageCount = validFiles.filter(f => f.type.startsWith('image/')).length;
            const docCount = validFiles.length - imageCount;
            let message = `Added ${validFiles.length} file(s)`;
            if (imageCount > 0 && docCount > 0) {
                message += ` (${imageCount} image${imageCount > 1 ? 's' : ''}, ${docCount} document${docCount > 1 ? 's' : ''})`;
            } else if (imageCount > 0) {
                message += ` (${imageCount} image${imageCount > 1 ? 's' : ''})`;
            }

            // Optional: Show a brief success message
            console.log(message);
        }

        // Clear the input so the same files can be selected again if needed
        event.target.value = '';
    };

    const handleRemoveFile = (index) => {
        const newFiles = uploadedFiles.filter((_, i) => i !== index);
        setUploadedFiles(newFiles);

        if (onFileChange) {
            onFileChange(newFiles);
        }
    };
    const handleUploadFiles = async () => {
        if (uploadedFiles.length === 0) {
            showAlert('Please select files to upload');
            return;
        }

        // ✅ Dynamically get measurementId from selected owner
        const measurementId = selectedOwnerInDetails?.land_owner_id || selectedOwner?.land_owner_id;

        if (!measurementId) {
            showAlert('Measurement ID not found. Cannot upload.');
            return;
        }

        setLoading(true);

        try {
            const measurementData = {};

            uploadedFiles.forEach((file, index) => {
                if (!file) return; // ✅ Skip null/undefined

                if (file.type.startsWith('image/')) {
                    measurementData[`image_${index}`] = file;
                } else {
                    measurementData[`document_${index}`] = file;
                }
            });


            const response = await apiService.patchUpdateMeasurement(measurementId, measurementData);

            if (response.status === 200) {
                showAlert(`Successfully uploaded ${uploadedFiles.length} file(s)!`);

                const names = uploadedFiles.map(file => file.name);
                setUploadedFileNames(prev => [...prev, ...names]);

                setUploadedFiles([]);

                // ✅ Optionally reload file list after upload
                loadExistingFiles();
            } else {
                showAlert('Upload failed');
            }
        } catch (error) {
            console.error('Upload error:', error);
            showAlert(`Upload failed: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };


    const validateFiles = (files) => {
        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
            'application/pdf', 'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'text/plain'
        ];

        const errors = [];

        files.forEach((file, index) => {
            if (file.size > maxFileSize) {
                errors.push(`File ${index + 1} (${file.name}) is too large. Maximum size is 10MB.`);
            }

            if (!allowedTypes.includes(file.type)) {
                errors.push(`File ${index + 1} (${file.name}) has unsupported type: ${file.type}`);
            }
        });

        return errors;
    };

    // Enhanced file size formatter
    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 B';

        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    };

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        const validationErrors = validateFiles(files);

        if (validationErrors.length > 0) {
            showAlert('File validation errors:\n' + validationErrors.join('\n'));
            return;
        }

        setUploadedFiles(files);
    };


    const handleViewFile = (file) => {
        if (file.type === 'image') {
            setSelectedFilePreview(file);
            setViewMode('preview');
        } else {
            // For non-image files, open in new tab
            window.open(file.url, '_blank');
        }
    };

    const getFileIcon = (type) => {
        switch (type) {
            case 'image': return <Image className="h-4 w-4" />;
            case 'pdf': return <FileType className="h-4 w-4" />;
            default: return <FileText className="h-4 w-4" />;
        }
    };

    // const formatFileSize = (bytes) => {
    //     return (bytes / 1024 / 1024).toFixed(2);
    // };
    // const handleOwnerNameClick = (ownerData) => {
    //     console.log('Owner clicked:', ownerData);

    //     // Store owner data in localStorage
    //     localStorage.setItem('triggerOwnerModal', JSON.stringify(ownerData));

    //     // Navigate back to main view
    //     if (onBack) {
    //         onBack();
    //     }
    // };

    const handleOwnerNameClick = (owner) => {
        setSelectedOwner(owner);
        setSelectedOwnerInDetails(owner);
        setSelectedOwnerIndex(ownersData.findIndex(o => o.land_owner_id === owner.land_owner_id));

        // Populate edit form data with owner details
        setEditFormData({
            ...editFormData,
            land_owner_id: owner.land_owner_id || '',
            owner_name: owner.owner_name || '',
            owner_type: owner.owner_type || '',
            owner_contact: owner.owner_contact || '',
            owner_email: owner.owner_email || '',
            owner_address: owner.owner_address || '',
            owner_portion: owner.owner_portion || '',
            owner_land_portion: owner.owner_land_portion || '',
            land_area: owner.land_area || '',
            land_category: owner.land_category || '',
            land_use: owner.land_use || '',
            latitude: owner.latitude || '',
            longitude: owner.longitude || '',
            no_of_tree: owner.no_of_tree || '',
            no_of_home: owner.no_of_home || '',
            no_of_tinshed: owner.no_of_tinshed || '',
            no_of_other_asset: owner.no_of_other_asset || '',
            no_of_water_body: owner.no_of_water_body || '',
            no_of_borewell: owner.no_of_borewell || '',
            no_of_pipeline: owner.no_of_pipeline || '',
            no_of_wirefencing: owner.no_of_wirefencing || '',
            no_of_other_asset: owner.no_of_other_asset || '',
            remarks: owner.remarks || '',
            solatium_percentage: owner.solatium_percentage || '',
            total_percentage: owner.total_percentage || '',
            aadhaar_number: owner.aadhaar_number || '',
            pan_number: owner.pan_number || ''
        });
        setShowEditOwner(true);
        // Trigger highlight effect
        setHighlightSummary(true);

        // Remove highlight after 3 seconds
        setTimeout(() => {
            setHighlightSummary(false);
        }, 3000);
    };

    const getFieldError = (field, value) => {
        switch (field) {
            case 'owner_contact':
                if (!/^\d{10}$/.test(value)) return 'Contact number must be 10 digits';
                break;
            case 'owner_email':
                if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email address';
                break;
            case 'aadhaar_number':
                if (value && !/^\d{12}$/.test(value)) return 'Aadhaar must be 12 digits';
                break;
            case 'pan_number':
                if (value && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) return 'Invalid PAN number';
                break;
            default:
                return '';
        }
        return '';
    };

    // Initialize data when component mounts
    useEffect(() => {

        fetchMeasurementData();
    }, [landAcquisitionId]);

    const fetchMeasurementData = async () => {
        if (!landAcquisitionId) {
            console.error('No landAcquisitionId provided');
            setError('Land Acquisition ID is required');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            console.log('Fetching measurement data for ID:', landAcquisitionId);
            const response = await apiService.getMeasurementByLandId(landAcquisitionId);

            console.log('API Response:', response);

            if (response?.status === 200) {
                // Set landAcquisition data (contains landholder_name)
                if (response.landAcquisition) {
                    setLandAcquisitionData(response.landAcquisition);
                    setLandAcquisition(response.landAcquisition);

                    // Set form data from landAcquisition object - Updated mapping
                    setEditFormData({
                        project_id: response.landAcquisition.project_id || 2,
                        village_id: response.landAcquisition.village_id || 1,
                        survey_no: response.landAcquisition.land_survey_no || '',
                        aqr_area: parseFloat(response.landAcquisition.aqr_area) || 0,
                        area_unit_id: response.landAcquisition.area_unit_id || 'ACRE',
                        landholder_name: response.landAcquisition.landholder_name || '',
                        survey_type: response.landAcquisition.survey_type || 'Revenue',
                        irrigable_type: response.landAcquisition.irrigable_type || '',
                        irrigable_area: response.landAcquisition.irrigable_area || '',
                        non_irrigable_area: response.landAcquisition.non_irrigable_area || '',
                        total_area: response.landAcquisition.total_area || '',
                        akoom: response.landAcquisition.akoom || '',
                        dist_no: response.landAcquisition.dist_no || '',
                        tehsil_no: response.landAcquisition.tehsil_no || '',
                        // Add owner data from first owner if available
                        latitude: response.data[0]?.latitude || '',
                        longitude: response.data[0]?.longitude || '',
                        no_of_tree: response.data[0]?.no_of_tree || '',
                        no_of_home: response.data[0]?.no_of_home || '',
                        no_of_tinshed: response.data[0]?.no_of_tinshed || '',
                        no_of_other_asset: response.data[0]?.no_of_other_asset || '',
                        no_of_water_body: response.data[0]?.no_of_water_body || '',
                        no_of_borewell: response.data[0]?.no_of_borewell || '',
                        no_of_pipeline: response.data[0]?.no_of_pipeline || '',
                        no_of_wirefencing: response.data[0]?.no_of_wirefencing || '',
                        no_of_other_asset: response.data[0]?.no_of_other_asset || '',
                        remarks: response.data[0]?.remarks || '',
                        owner_name: response.data[0]?.owner_name || '',
                        owner_type: response.data[0]?.owner_type || '',
                        owner_contact: response.data[0]?.owner_contact || '',
                        owner_email: response.data[0]?.owner_email || '',
                        owner_address: response.data[0]?.owner_address || '',
                        bank_name: response.data[0]?.bank_name || '',
                        branch_name: response.data[0]?.branch_name || '',
                        account_number: response.data[0]?.account_number || '',
                        aadhaar_number: response.data[0]?.aadhaar_number || '',
                        pan_number: response.data[0]?.pan_number || '',
                        ifsc_code: response.data[0]?.ifsc_code || '',
                        account_holder_name: response.data[0]?.account_holder_name || '',
                        // 🌿 From owner (data[0])
                        owner_total_area: response.data[0]?.owner_total_area || '',
                        owner_aqr_area: response.data[0]?.owner_aqr_area || '',
                        solatium_percentage: response.data[0]?.solatium_percentage || '',

                        // 🌿 From landAcquisition
                        total_area: response.landAcquisition.total_area || '',
                        totalLandArea: response.landAcquisition.totalLandArea || '',
                        totalOwnerCompleted: response.landAcquisition.totalOwnerCompleted || '',
                        totalOwnerRequired: response.landAcquisition.totalOwnerRequired || ''
                    });
                }

                if (Array.isArray(response.data) && response.data.length > 0) {
                    setOwnersData(response.data);
                    setOwners(response.data);
                    setSelectedOwner(response.data[0]);
                    setSelectedOwnerInDetails(response.data[0]);
                    setSelectedOwnerData(response.data[0]);
                }
                else {
                    setOwners([]);
                    setSelectedOwnerInDetails(null);
                }

            } else {
                setError('Failed to fetch measurement data');
            }
        } catch (error) {
            console.error('Error fetching measurement data:', error);
            setError('Error occurred while fetching data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const storedMeasurementData = localStorage.getItem('selectedMeasurementData');

        if (storedMeasurementData) {
            try {
                const measurement = JSON.parse(storedMeasurementData);
                console.log('ViewMeasurementList received measurement:', measurement);

                if (measurement.owners && measurement.landAcquisition) {
                    if (measurement.measurementId) {
                        setMeasurementId(measurement.measurementId);
                    }
                    setOwners(measurement.owners);
                    setLandAcquisition(measurement.landAcquisition);

                    // Set form data from landAcquisition - Updated mapping
                    setEditFormData({
                        project_id: measurement.landAcquisition.project_id,
                        village_id: measurement.landAcquisition.village_id,
                        survey_no: measurement.landAcquisition.land_survey_no || '',
                        aqr_area: parseFloat(measurement.landAcquisition.aqr_area) || 0,
                        area_unit_id: measurement.landAcquisition.area_unit_id || 'ACRE',
                        landholder_name: measurement.landAcquisition.landholder_name || '',
                        survey_type: measurement.landAcquisition.survey_type || 'Revenue',
                        irrigable_type: measurement.landAcquisition.irrigable_type || '',
                        irrigable_area: measurement.landAcquisition.irrigable_area || '',
                        non_irrigable_area: measurement.landAcquisition.non_irrigable_area || '',
                        total_area: measurement.landAcquisition.total_area || '',
                        // is_active: measurement.landAcquisition.is_active ?? 1,
                        // land_no: measurement.landAcquisition.land_no || '',
                        dist_no: measurement.landAcquisition.dist_no || '',
                        tehsil_no: measurement.landAcquisition.tehsil_no || ''
                    });

                    if (measurement.owners.length > 0) {
                        setSelectedOwnerInDetails(measurement.owners[0]);
                    }
                }
            } catch (error) {
                console.error('Error parsing stored measurement data:', error);
            }
        }
    }, []);


    const handleEditToggle = (rowIndex, ownerData) => {
        if (editingRowIndex === rowIndex) {
            // Cancel editing
            // setEditingRowIndex(null);
            // setErrors({});
            setEditingRowIndex(null);
            setEditFormData({});
        } else {
            // Start editing this row
            setEditingRowIndex(rowIndex);
            // setSelectedOwnerData(ownerData);

            // Set form data for this specific owner
            setEditFormData({
                ...editFormData,
                owner_name: ownerData.owner_name || '',
                owner_type: ownerData.owner_type || '',
                aadhaar_number: ownerData.aadhaar_number || '',
                pan_number: ownerData.pan_number || '',
                no_of_home: ownerData.no_of_home || '',
                no_of_tinshed: ownerData.no_of_tinshed || '',
                latitude: ownerData.latitude || '',
                longitude: ownerData.longitude || '',
                no_of_tree: ownerData.no_of_tree || '',
                no_of_other_asset: ownerData.no_of_other_asset || '',
                no_of_water_body: ownerData.no_of_water_body || '',
                no_of_borewell: ownerData.no_of_borewell || '',
                no_of_pipeline: ownerData.no_of_pipeline || '',
                no_of_wirefencing: ownerData.no_of_wirefencing || '',
                no_of_other_asset: ownerData.no_of_other_asset || '',
                remarks: ownerData.remarks || '',

            });
        }
    };

    // ✅ New handler: open EditOwner modal with correct data
    const handleEditButtonClick = (owner) => {
        console.log("🖊️ handleEditButtonClick received owner:", owner);
        setSelectedOwner(owner);
        setSelectedOwnerInDetails(owner);

        // Create fresh editFormData without spreading old data
        const newEditFormData = {
            // IDs and core data
            land_owner_id: owner.land_owner_id,
            LandAcquisition_id: owner.LandAcquisition_id,
            project_id: owner.project_id,
            proposal_id: owner.proposal_id,

            // Owner information
            owner_name: owner.owner_name || '',
            owner_type: owner.owner_type || '',
            owner_contact: owner.owner_contact || '',
            owner_email: owner.owner_email || '',
            owner_address: owner.owner_address || '',
            aadhaar_number: owner.aadhaar_number || '',
            pan_number: owner.pan_number || '',

            // Location
            latitude: owner.latitude || '',
            longitude: owner.longitude || '',

            // Land details
            survey_no: owner.survey_no || '',
            land_area: owner.land_area || '',
            land_category: owner.land_category || '',
            land_use: owner.land_use || '',

            // Assets (matching your JSON structure)
            no_of_tree: owner.no_of_tree || '',
            no_of_home: owner.no_of_home || '',
            no_of_tinshed: owner.no_of_tinshed || '',
            no_of_water_body: owner.no_of_water_body || '',
            no_of_borewell: owner.no_of_borewell || '',
            no_of_pipeline: owner.no_of_pipeline || '',
            no_of_wirefencing: owner.no_of_wirefencing || '',
            no_of_fram_pound: owner.no_of_fram_pound || '', // ✅ Added missing field
            no_of_other_asset: owner.no_of_other_asset || '',

            // Other fields
            remarks: owner.remarks || '',
            solatium_percentage: owner.solatium_percentage || '',
            total_percentage: owner.total_percentage || ''
        };

        setEditFormData(newEditFormData);

        // Log the data being set (not editFormData which is stale)
        console.log("📝 Setting editFormData with:", {
            land_owner_id: owner.land_owner_id,
            owner_name: owner.owner_name,
            owner_type: owner.owner_type
        });

        // Open modal
        setShowEditOwner(true);
    };


    // const handleEditToggle = () => {
    //     if (isEditing) {
    //         // Reset form data when canceling edit
    //         if (landAcquisition) {
    //             setEditFormData({
    //                 project_id: landAcquisition.project_id || 2,
    //                 village_id: landAcquisition.village_id || 1,
    //                 survey_no: landAcquisition.land_survey_no || '',
    //                 aqr_area: parseFloat(landAcquisition.aqr_area) || 0,
    //                 area_unit_id: landAcquisition.area_unit_id || 'ACRE',
    //                 landholder_name: landAcquisition.landholder_name || '',
    //                 survey_type: landAcquisition.survey_type || 'Revenue',
    //                 irrigable_type: landAcquisition.irrigable_type || '',
    //                 irrigable_area: landAcquisition.irrigable_area || '',
    //                 non_irrigable_area: landAcquisition.non_irrigable_area || '',
    //                 owner_total_area: landAcquisition.owner_total_area || '',
    //                 // is_active: landAcquisition.is_active ?? 1,
    //                 // land_no: landAcquisition.land_no || '',
    //                 District_no: landAcquisition.District_no || '',
    //                 taluka_no: landAcquisition.taluka_no || ''
    //             });
    //         }
    //     }
    //     setIsEditing(!isEditing);
    //     setErrors({}); // Clear any existing errors
    // };

    const handleFormChange = (field, value) => {
        setEditFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    // Validation function
    const validateFormData = () => {
        const newErrors = {};

        if (!editFormData.survey_no?.trim()) {
            newErrors.survey_no = 'Survey number is required';
        }

        if (!editFormData.landholder_name?.trim()) {
            newErrors.landholder_name = 'Landholder name is required';
        }

        if (!editFormData.total_area || parseFloat(editFormData.total_area) <= 0) {
            newErrors.total_area = 'Total area must be greater than 0';
        }

        if (!editFormData.aqr_area || parseFloat(editFormData.aqr_area) <= 0) {
            newErrors.aqr_area = 'Acquired area must be greater than 0';
        }

        // Check if acquired area is not greater than total area
        if (parseFloat(editFormData.aqr_area) > parseFloat(editFormData.total_area)) {
            newErrors.aqr_area = 'Acquired area cannot be greater than total area';
        }
        if (identityProofs.aadhaarNumber && !/^\d{12}$/.test(identityProofs.aadhaarNumber)) {
            newErrors.aadhaarNumber = 'Aadhaar number must be 12 digits';
        }

        if (identityProofs.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(identityProofs.panNumber)) {
            newErrors.panNumber = 'Invalid PAN number format';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleAddOwner = (result) => {
        console.log('Occupant added:', result);
        setShowAddOwner(false);
        setNewOwner({});
    };
    const handleEditOwner = (result) => {
        console.log('Occupant added:', result);
        setShowEditOwner(false);
        setEditFormData({});
    };
    const handleCancel = () => {
        setShowAddOwner(false);
        setNewOwner({});
    };
    const handleCancelEdit = () => {
        setShowEditOwner(false);
        setEditFormData({});
    };


    // const handleUpdate = async () => {
    //     try {
    //         setUpdating(true);

    //         const ownerToUpdate = ownersData[index];
    //         if (!ownerToUpdate?.land_owner_id) {
    //             alert('Owner ID not found. Cannot update.');
    //             return;
    //         }

    //         // Prepare update payload with data validation
    //         const updatePayload = {
    //             // Core IDs (required)
    //             project_id: selectedOwnerData.project_id || newOwner.project_id,
    //             LandAcquisition_id: selectedOwnerData.LandAcquisition_id || newOwner.LandAcquisition_id,

    //             // Owner Information
    //             owner_portion: newOwner.owner_portion || '',
    //             owner_land_portion: newOwner.owner_land_portion || '',
    //             owner_name: newOwner.owner_name || '',
    //             owner_type: newOwner.owner_type || '',
    //             owner_contact: newOwner.owner_contact || '',
    //             owner_email: newOwner.owner_email || '',
    //             owner_address: newOwner.owner_address || '',

    //             // ID Proof Details
    //             aadhaar_number: newOwner.aadhaar_number || '',
    //             id_proof_type: 'Aadhaar',
    //             id_proof_number: newOwner.aadhaar_number || '',
    //             pan_number: newOwner.pan_number || '',

    //             // Bank Details
    //             bank_name: newOwner.bank_name || '',
    //             branch_name: newOwner.branch_name || '',
    //             account_number: newOwner.account_number || '',
    //             ifsc_code: newOwner.ifsc_code || '',
    //             account_holder_name: newOwner.account_holder_name || '',

    //             // Land Details
    //             survey_no: newOwner.survey_no || '',
    //             village_name: newOwner.village_name || selectedOwnerData.village_name || '',
    //             taluka_name: newOwner.taluka_name || selectedOwnerData.taluka_name || '',
    //             district_name: newOwner.district_name || selectedOwnerData.district_name || '',
    //             land_area: newOwner.land_area || '',
    //             area_unit_id: newOwner.area_unit_id || 1,
    //             land_type_id: newOwner.land_type_id || 3,
    //             land_category: newOwner.land_category || '',
    //             land_use: newOwner.land_use || '',
    //             ownership_percentage: newOwner.ownership_percentage || 100,
    //             title_type: newOwner.title_type || 'Clear',

    //             // Dates
    //             acquisition_date: newOwner.acquisition_date || selectedOwnerData.acquisition_date || '',
    //             registration_date: newOwner.registration_date || selectedOwnerData.registration_date || '',

    //             // Document Details
    //             document_number: newOwner.document_number || selectedOwnerData.document_number || '',
    //             mutation_number: newOwner.mutation_number || selectedOwnerData.mutation_number || '',
    //             document_references: newOwner.document_references || selectedOwnerData.document_references || '',

    //             // Financial Values - ensure they're numbers and handle NaN
    //             land_value_rate: isNaN(parseFloat(newOwner.land_value_rate)) ? 0 : parseFloat(newOwner.land_value_rate),
    //             no_of_structure: isNaN(parseFloat(newOwner.no_of_structure)) ? 0 : parseFloat(newOwner.no_of_structure),
    //             no_of_tree: isNaN(parseFloat(newOwner.no_of_tree)) ? 0 : parseFloat(newOwner.no_of_tree),
    //             no_of_crop: isNaN(parseFloat(newOwner.no_of_crop)) ? 0 : parseFloat(newOwner.no_of_crop),
    //             no_of_water_body: isNaN(parseFloat(newOwner.no_of_water_body)) ? 0 : parseFloat(newOwner.no_of_water_body),
    //             no_of_other_asset: isNaN(parseFloat(newOwner.no_of_other_asset)) ? 0 : parseFloat(newOwner.no_of_other_asset),
    //             no_of_pipeline: isNaN(parseFloat(newOwner.no_of_pipeline)) ? 0 : parseFloat(newOwner.no_of_pipeline),
    //             no_of_wirefencing: isNaN(parseFloat(newOwner.no_of_wirefencing)) ? 0 : parseFloat(newOwner.no_of_wirefencing),

    //             // Additional Fields
    //             has_objection: newOwner.has_objection || 0,
    //             objection_id: newOwner.objection_id || null,
    //             award_number: newOwner.award_number || selectedOwnerData.award_number || '',
    //             award_date: newOwner.award_date || selectedOwnerData.award_date || '',
    //             is_active: 1,
    //         };

    //         // Calculate land_value_total and solatium
    //         const landArea = isNaN(parseFloat(newOwner.land_area)) ? 0 : parseFloat(newOwner.land_area);
    //         const landValueRate = updatePayload.land_value_rate;
    //         updatePayload.land_value_total = landArea * landValueRate;

    //         // Calculate solatium
    //         const solatiumPercentage = isNaN(parseFloat(newOwner.solatium_percentage)) ? 0 : parseFloat(newOwner.solatium_percentage);
    //         updatePayload.solatium_percentage = solatiumPercentage;

    //         const totalCompensation =
    //             updatePayload.land_value_total +
    //             updatePayload.no_of_structure +
    //             updatePayload.no_of_tree +
    //             updatePayload.no_of_crop +
    //             updatePayload.no_of_water_body +
    //             updatePayload.no_of_other_asset +
    //             updatePayload.no_of_pipeline +
    //             updatePayload.no_of_wirefencing;

    //         updatePayload.solatium_amount = (totalCompensation * solatiumPercentage) / 100;

    //         console.log('🔄 Starting update process...');
    //         console.log('Measurement ID:', selectedOwnerData.land_owner_id);
    //         console.log('Update payload:', updatePayload);

    //         // Try the update - prefer JSON method as it's more reliable
    //         let response;
    //         try {
    //             console.log('📤 Attempting update...');
    //             response = await apiService.patchUpdateMeasurement(
    //                 selectedOwnerData.land_owner_id,
    //                 updatePayload
    //             );
    //         } catch (apiError) {
    //             console.error('❌ API call failed:', apiError);
    //             throw apiError; // Re-throw to be caught by outer try-catch
    //         }

    //         console.log('✅ API Response received:', response);

    //         if (response?.status === 200) {
    //             alert('Measurement details updated successfully!');
    //             setShowAddOwner(false);
    //             setIsEditing(false);

    //             // Reset the form
    //             setNewOwner({
    //                 owner_portion: '', owner_land_portion: '', owner_name: '', owner_type: '',
    //                 owner_contact: '', owner_email: '', owner_address: '', aadhaar_number: '',
    //                 pan_number: '', bank_name: '', branch_name: '', account_number: '',
    //                 ifsc_code: '', account_holder_name: '', survey_no: '', land_area: '',
    //                 land_category: '', land_use: '', land_value_rate: '', no_of_structure: '',
    //                 no_of_tree: '', no_of_water_body: '', no_of_other_asset: '', no_of_pipeline: '',
    //                 no_of_wirefencing: '', solatium_percentage: '', total_percentage: ''
    //             });

    //             setSelectedOwnerData(null);

    //             // Optionally refresh data
    //             // await fetchUpdatedData(); // Uncomment if you have a refresh function

    //         } else {
    //             console.error('❌ Unexpected response status:', response?.status);
    //             alert(`Update failed with status: ${response?.status}. Please try again.`);
    //         }
    //     } catch (error) {
    //         console.error('❌ handleUpdate Error:', error);

    //         let errorMessage = 'An error occurred while updating measurement details';

    //         if (error.message) {
    //             errorMessage = error.message;
    //         }

    //         // Show user-friendly error message
    //         alert(`Update Failed: ${errorMessage}`);
    //     } finally {
    //         setUpdating(false);
    //     }
    //     setEditingRowIndex(null);
    //     setSelectedOwnerData(null);
    // };

    const handleUpdate = async (index) => {
        try {
            setUpdating(true);

            const ownerToUpdate = ownersData[index];
            if (!ownerToUpdate?.land_owner_id) {
                showAlert('Occupant ID not found. Cannot update.');
                return;
            }

            const updatePayload = {
                project_id: ownerToUpdate.project_id || 2,
                LandAcquisition_id: ownerToUpdate.LandAcquisition_id,
                owner_name: editFormData.owner_name || '',
                owner_type: editFormData.owner_type || '',
                aadhaar_number: editFormData.aadhaar_number || '',
                pan_number: editFormData.pan_number || '',
                owner_contact: editFormData.owner_contact || '',
                owner_email: editFormData.owner_email || '',
                owner_address: editFormData.owner_address || '',
                latitude: parseFloat(editFormData.latitude) || 0,
                latitude: parseFloat(editFormData.latitude) || 0,
                longitude: parseFloat(editFormData.longitude) || 0,
                no_of_home: parseFloat(editFormData.no_of_home) || 0,
                no_of_tinshed: parseFloat(editFormData.no_of_tinshed) || 0,
                no_of_water_body: parseFloat(editFormData.no_of_water_body) || 0,
                no_of_borewell: parseFloat(editFormData.no_of_borewell) || 0,
                no_of_pipeline: parseFloat(editFormData.no_of_pipeline) || 0,
                no_of_wirefencing: parseFloat(editFormData.no_of_wirefencing) || 0,
                no_of_other_asset: parseFloat(editFormData.no_of_other_asset) || 0,
                remarks: editFormData.remarks || '',
                // remarks: parseFloat(editFormData.remarks) || 0,

                is_active: 1
            };

            console.log('Updating row:', index, updatePayload);

            const response = await apiService.patchUpdateMeasurement(
                ownerToUpdate.land_owner_id,
                updatePayload
            );

            if (response?.status === 200) {
                showAlert('Occupant updated successfully!');
                setEditingRowIndex(null);
                refreshMeasurementData(); // Refresh after update
            } else {
                showAlert('Update failed. Please try again.');
            }
        } catch (error) {
            console.error('Update error:', error);
            showAlert('An error occurred while updating. Please try again.');
        } finally {
            setUpdating(false);
        }
    };


    const handleLandholderClick = (landAcquisition) => {
        // Handle landholder click if needed
        console.log('Landholder clicked:', landAcquisition);
    };

    // Calculate financial summary
    const calculateFinancialSummary = () => {
        if (!owners || owners.length === 0) {
            return {
                landValue: 0,
                structureValue: 0,
                treeValue: 0,
                cropValue: 0,
                solatiumAmount: 0,
                totalCompensation: 0
            };
        }

        const landValue = parseFloat(landAcquisition?.total_area || 0) * 1000;
        const structureValue = owners.reduce((sum, owner) => sum + parseFloat(owner.structure_compensation || 0), 0);
        const treeValue = owners.reduce((sum, owner) => sum + parseFloat(owner.tree_compensation || 0), 0);
        const cropValue = owners.reduce((sum, owner) => sum + parseFloat(owner.no_of_other_asset || 0), 0);

        // Use dynamic solatium percentage
        const baseAmount = landValue + structureValue + treeValue + cropValue;
        const solatiumAmount = baseAmount * (solatiumPercentage / 100);
        const totalCompensation = baseAmount + solatiumAmount;

        // Calculate total percentage (this could be total compensation as % of some base value)
        const calculatedTotalPercentage = totalCompensation > 0 ? ((totalCompensation / baseAmount - 1) * 100) : 0;

        // Update total percentage state
        if (calculatedTotalPercentage !== totalPercentage) {
            setTotalPercentage(calculatedTotalPercentage);
        }

        return {
            landValue,
            structureValue,
            treeValue,
            cropValue,
            solatiumAmount,
            totalCompensation
        };
    };

    const financialSummary = calculateFinancialSummary();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-80">
                <div className="text-center animate-float">
                    <div className="inline-flex relative">
                        <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                        <div
                            className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0"
                            style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
                        ></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                            <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                        </div>
                    </div>
                    <p className="text-gray-400 mt-4">{translations[language]?.loadingMeasurementDetails}</p>
                </div>
            </div>
        );
    }

    if (!landAcquisition) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="text-center">
                    <p className="text-red-600">{translations[language]?.noMeasurementData}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full bg-white">
            <div className="p-6 border-b bg-gray-50">
                <div className="flex items-center justify-between">
                    {/* Left side - Back button and location info */}
                    <div className="flex items-center space-x-6">
                        <button
                            onClick={onBack}
                            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors"
                        >
                            <ArrowLeft className="h-5 w-5" />
                        </button>

                        <div className="flex items-center space-x-8">
                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.district}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.dist_name || 'N/A'}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.taluka}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.taluka_name || 'N/A'}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-600">{translations[language]?.village}</label>
                                <p className="text-gray-800 font-medium">
                                    {landAcquisition.village_name || 'N/A'}
                                </p>
                            </div>
                        </div>


                        {showconfirm && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">{translations[language]?.confirmDownload}</h3>
                                    <p className="text-gray-600 mb-6">{translations[language]?.confirmDownloadMessage}</p>
                                    <div className="flex justify-end space-x-3">

                                        <button
                                            onClick={() => setShowConfirm(false)}
                                            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-lg transition-colors"
                                        >
                                            {translations[language]?.cancel}
                                        </button>
                                        <button
                                            onClick={handleDownloadPDF}
                                            className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
                                        >
                                            {translations[language]?.download}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>


                    <button
                        onClick={() => setShowConfirm(true)}
                        className="px-4 py-2  bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors flex items-center space-x-2"
                    >
                        <Download className="h-4 w-4" />
                        <span>{translations[language]?.download} </span>
                    </button>
                </div>
            </div>


            {/* Error Message */}
            {error && (
                <div className="mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-red-600 text-sm">{error}</p>
                </div>
            )}

            {/* Rest of the component content - scrollable */}
            <div className="max-h-screen overflow-y-auto p-6">
                {/* Enhanced Main Data Table */}
                <div className="bg-white border-2 border-gray-300 rounded-lg overflow-hidden mb-6 shadow-sm">
                    {/* Add Owner Button - Prominently placed at the top */}
                    {userRole === USER_ROLES.SURVEYOR && (
                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-6 py-4">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-800">{translations[language]?.occupantsManagement}</h3>
                                    <p className="text-sm text-gray-600">{translations[language]?.addOrManageOccupants}</p>
                                </div>

                                <button
                                    onClick={() => setShowAddOwner(true)}
                                    className="flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                                >
                                    <Plus className="h-5 w-5" />
                                    <span className="font-medium">{translations[language]?.addNewOccupantName}</span>
                                </button>
                            </div>
                        </div>
                    )}

                    <div className="overflow-x-auto">
                        <table className="min-w-full">
                            <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                                {/* 🔹 First Row (Main Group Headings) */}
                                <tr>
                                    {(userRole === USER_ROLES.SURVEYOR) && (
                                        <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                            Action
                                        </th>
                                    )}
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        अ.क्र
                                    </th>
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        भूमापन क्रमांक (स.नं./ ग.नं.)
                                    </th>
                                    <th colSpan="3" className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-blue-100">
                                        भूमापन अभिलेखानुसार तपशिल
                                    </th>
                                    <th colSpan="4" className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-yellow-100">
                                        प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल
                                    </th>
                                    <th colSpan="4" className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-green-100">
                                        प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल
                                    </th>
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        कब्जेदाराचे नाव
                                    </th>
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        कब्जेदाराचे हक्क संपादनाचे स्वरुप
                                    </th>
                                    <th colSpan="6" className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-100">
                                        संपादनाखालील क्षेत्रावरील इतर घटक
                                    </th>
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        गाव नकाशा व मोका परिस्थिती यामध्ये तफावत असल्यास, त्याची कायदेशिरदृष्टया समर्पक कारणमिमांसा
                                    </th>
                                    <th rowSpan="2" className="px-4 py-3 border-r border-gray-300 text-center font-bold">
                                        शेरा
                                    </th>

                                </tr>

                                {/* 🔹 Second Row (Sub-Headings) */}
                                <tr>
                                    {/* भूमापन अभिलेखानुसार तपशिल */}
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-blue-50">लागवडयोग्य क्षेत्र</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-blue-50">पोट खराब क्षेत्र</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-blue-50">एकूण क्षेत्र (हे.आर.)</th>
                                    {/* <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-blue-50">आकारणी</th> */}

                                    {/* प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल */}
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-yellow-50">सव्र्व्हे नं. / गट नंबर</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-yellow-50">अधिकार अभिलेखानुसार भुधारकाचे नाव</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-yellow-50">धारण केलेले क्षेत्र (हे.आर.)</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-yellow-50">संपादनाखालील अंदाजे क्षेत्र (हे.आर.)</th>

                                    {/* प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल */}
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-green-50">सर्व्हे नं. / गट नंबर</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-green-50">लागवडयोग्य क्षेत्र</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-green-50">पोट खराब क्षेत्र</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-green-50">संपादनाखालील एकूण क्षेत्र (हे.आर.)</th>

                                    {/* संपादनाखालील क्षेत्रावरील इतर घटक */}
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">फळझाडे (प्रकार संख्या)</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">वनझाडे (प्रकार / संख्या)</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">विहीर / बोअरवेल (प्रकार/ संख्या)</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">पाईपलाईन</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">बांधकाम (स्वरुप /तपशिल)</th>
                                    <th className="px-4 py-3 border-r border-gray-300 text-center font-bold bg-purple-50">इतर</th>
                                </tr>
                            </thead>

                            <tbody className="bg-white">
                                {landAcquisitionData ? (
                                    (ownersData && ownersData.length > 0 ? ownersData : [{}]).map((owner, index) => {
                                        const isSelected = selectedOwnerIndex === index;
                                        const isFirstRow = index === 0;
                                        const isCurrentRowEditing = editingRowIndex === index; // ✅ Row-specific editing

                                        return (
                                            <tr key={owner.land_owner_id || index} className={`hover:bg-gray-50 transition-colors ${isSelected ? 'bg-blue-50 border-2 border-blue-200' : ''}`}>
                                                {userRole === USER_ROLES.SURVEYOR && (
                                                    <td className="px-4 py-4 text-center bg-gray-50">
                                                        <div className="flex items-center justify-center space-x-2">
                                                            <>
                                                                {!isCurrentRowEditing ? (
                                                                    <button
                                                                        onClick={() => handleEditButtonClick(owner)} // ✅ Pass the specific owner
                                                                        className="flex items-center space-x-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors"
                                                                    >
                                                                        <Edit className="h-4 w-4" />
                                                                        <span>{translations[language]?.edit}</span>
                                                                    </button>
                                                                ) : (
                                                                    <>
                                                                        <button
                                                                            onClick={() => handleEditButtonClick(owner)}
                                                                            disabled={updating}
                                                                            className="flex items-center space-x-2 px-3 py-1 bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white rounded transition-colors"
                                                                        >
                                                                            {updating ? (
                                                                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                                            ) : (
                                                                                <Save className="h-4 w-4" />
                                                                            )}
                                                                            {updating ? <span>{translations[language]?.saving}</span> : <span>{translations[language]?.save}</span>}
                                                                        </button>
                                                                        <button
                                                                            onClick={() => setEditingRowIndex(null)}
                                                                            className="flex items-center space-x-2 px-3 py-1 bg-gray-600 hover:bg-gray-700 text-white rounded transition-colors"
                                                                        >
                                                                            <span>{translations[language]?.cancel}</span>
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </>
                                                        </div>
                                                    </td>
                                                )}
                                                {/* sr no */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {index + 1}
                                                </td>

                                                {/* bhumapan kramak s.no/ gat no  */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (editFormData.survey_no || landAcquisitionData.land_survey_no || 'N/A') : ''}
                                                </td>

                                                {/* भूमापन अभिलेखानुसार तपशिल Cultivable Area*/}

                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.irrigable_area || 'N/A') : ''}
                                                </td>
                                                {/* Abdominal Area*/}

                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.non_irrigable_area || 'N/A') : ''}
                                                </td>
                                                {/* Total Area*/}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.total_area || 'N/A') : ''}
                                                </td>
                                                {/* Levy */}
                                                {/* <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.aqr_area || 'N/A') : ''}
                                                </td> */}

                                                {/* प्रस्तावानुसार संपादनाखालील क्षेत्राचा तपशिल dastavej mujab sapadan vistar ni vigat*/}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (editFormData.survey_no || landAcquisitionData.land_survey_no || 'N/A') : ''}
                                                </td>

                                                {/* jamin malik nu name jaminna datavej mujab */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.landholder_name || 'N/A') : ''}
                                                </td>

                                                {/* yojayel vigat*/}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.aqr_area || 'N/A') : ''}
                                                </td>
                                                {/* vistar hector */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (editFormData.irrigable_area || 'N/A') : ''}
                                                </td>

                                                {/* प्रत्यक्ष मोजणीअंती संपादनाखालील क्षेत्राचा तपशिल */}
                                                {/*  sr no  */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (editFormData.survey_no || landAcquisitionData.land_survey_no || 'N/A') : ''}
                                                </td>

                                                {/* Irrigable Area */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.irrigable_area || 'N/A') : ''}
                                                </td>


                                                {/* Non-Irrigable Area */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.non_irrigable_area || 'N/A') : ''}
                                                </td>

                                                {/* total aquired area */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {isFirstRow ? (landAcquisitionData.total_area || 'N/A') : ''}
                                                </td>

                                                {/* कब्जेदाराचे नाव */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {owner.owner_name || 'N/A'}
                                                </td>

                                                {/* कब्जेदाराचे हक्क संपादनाचे स्वरुप */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base font-semibold text-blue-600">
                                                    {owner.owner_type || 'N/A'}
                                                </td>
                                                {/* Tree */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50 whitespace-nowrap">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_tree}
                                                            onChange={(e) => handleFormChange('no_of_tree', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Tree Count"
                                                        />
                                                    ) : (
                                                        <div className="inline-block text-left">
                                                            {owner.tree && owner.tree.length > 0 ? (
                                                                owner.tree
                                                                    // chunk into groups of 2
                                                                    .reduce((rows, t, i) => {
                                                                        if (i % 2 === 0) rows.push([t]);
                                                                        else rows[rows.length - 1].push(t);
                                                                        return rows;
                                                                    }, [])
                                                                    .map((pair, rowIndex) => (
                                                                        <div key={rowIndex}>
                                                                            {pair.map((t, i) => (
                                                                                <span key={i}>
                                                                                    {t.tree_count} {t.tree_type_name}
                                                                                    {i < pair.length - 1 ? ', ' : ''}
                                                                                </span>
                                                                            ))}
                                                                        </div>
                                                                    ))
                                                            ) : (
                                                                owner.no_of_tree || '0'
                                                            )}
                                                        </div>
                                                    )}
                                                </td>


                                                {/* वनझाडे Well, Shev Lake */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_water_body}
                                                            onChange={(e) => handleFormChange('no_of_water_body', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Water Body Value"
                                                        />
                                                    ) : (owner.no_of_water_body || '0')}
                                                </td>

                                                {/* no_of_borewell */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_borewell}
                                                            onChange={(e) => handleFormChange('no_of_borewell', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="no_of_borewell Value"
                                                        />
                                                    ) : (owner.no_of_borewell || '0')}
                                                </td>

                                                {/* Pipeline */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_pipeline}
                                                            onChange={(e) => handleFormChange('no_of_pipeline', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Pipeline Value"
                                                        />
                                                    ) : (owner.no_of_pipeline || '0')}
                                                </td>
                                                {/* बांधकाम (स्वरुप /तपशिल) - Construction Details */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50 whitespace-nowrap">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_home}
                                                            onChange={(e) => handleFormChange('no_of_home', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Home Count"
                                                        />
                                                    ) : (
                                                        <div className="inline-block text-left">
                                                            {owner.home && owner.home.length > 0 ? (
                                                                owner.home
                                                                    .reduce((rows, h, i) => {
                                                                        if (i % 1 === 0) rows.push([h]); // Display one home per row
                                                                        else rows[rows.length - 1].push(h);
                                                                        return rows;
                                                                    }, [])
                                                                    .map((homeGroup, rowIndex) => (
                                                                        <div key={rowIndex} className="mb-1">
                                                                            {homeGroup.map((h, i) => (
                                                                                <div key={i} className="text-xs">
                                                                                    <div className="font-medium">
                                                                                        {h.house_floor_no?.replace(/_/g, ' ')?.replace(/\b\w/g, l => l.toUpperCase()) || 'Floor'}
                                                                                    </div>
                                                                                    <div>
                                                                                        {h.Property_width}×{h.Property_length} {h.construction_type ? `(${h.construction_type})` : ''}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ))
                                                            ) : (
                                                                owner.no_of_home || '0'
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                {/* Wire Fence */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_other_asset}
                                                            onChange={(e) => handleFormChange('no_of_other_asset', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Wire Value"
                                                        />
                                                    ) : (owner.no_of_other_asset || editFormData.no_of_other_asset || '0')}
                                                </td>
                                                {/*Wire Fence*/}
                                                <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            value={editFormData.no_of_other_asset}
                                                            onChange={(e) => handleFormChange('no_of_other_asset', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Wire Value"
                                                        />
                                                    ) : (owner.no_of_other_asset || editFormData.no_of_other_asset || '0')}
                                                </td>
                                                {/* Remarks */}
                                                <td className="px-4 py-4 border-r border-gray-300 text-left text-base text-gray-800 bg-green-50">
                                                    {isCurrentRowEditing ? (
                                                        <textarea
                                                            value={editFormData.remarks}
                                                            onChange={(e) => handleFormChange('remarks', e.target.value)}
                                                            className="w-full px-2 py-1 border border-gray-300 rounded text-sm resize-none focus:ring-2 focus:ring-blue-500"
                                                            placeholder="Remarks"
                                                            rows="2"
                                                        />
                                                    ) : (owner.remarks || editFormData.remarks || '-')}
                                                </td>

                                                {/* Delete Column for LAO */}
                                                {userRole === USER_ROLES.LAO && (
                                                    <td className="px-4 py-4 border-r border-gray-300 text-center text-base text-gray-800">
                                                        <button
                                                            onClick={() => handleDeleteRecord(owner)}
                                                            disabled={loading || Number(owner.is_active) === 0}
                                                            className={`${Number(owner.is_active) === 0
                                                                ? 'bg-gray-400 cursor-not-allowed'
                                                                : 'bg-red-600 hover:bg-red-700'
                                                                } disabled:bg-gray-400 text-white px-3 py-2 rounded-md text-sm inline-flex items-center gap-2 transition-all duration-200 shadow-sm hover:shadow-md`}
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                            {Number(owner.is_active) === 0 ? 'Deleted' : loading ? 'Deleting...' : 'Delete'}
                                                        </button>
                                                    </td>
                                                )}


                                                {/* <button
                                                    onClick={handleEditToggle}
                                                    className="flex items-center space-x-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors shadow-sm"
                                                >
                                                    <Edit className="h-4 w-4" />
                                                    <span>Edit</span>
                                                </button> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={userRole === USER_ROLES.LAO ? "19" : "18"} className="px-4 py-8 text-center text-gray-500">
                                            <div className="flex flex-col items-center gap-2">
                                                <FileText className="w-12 h-12 text-gray-300" />
                                                <p>{translations[language]?.noMeasurementData}</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Fixed Add Owner Modal */}
                    {showAddOwner && (
                        <AddOwner
                            landAcquisitionId={landAcquisitionId}
                            onAdd={handleOwnerAdded}
                            newOwner={newOwner}
                            setNewOwner={setNewOwner}
                            onCancel={() => setShowAddOwner(false)}
                            onRefresh={refreshMeasurementData}
                            // landAcquisition={landAcquisitionData}
                            landAcquisition={landAcquisition}
                            apiService={apiService}
                            setShowAddOwner={setShowAddOwner}
                            setOwnersData={setOwnersData}
                            setOwners={setOwners}
                            setSelectedOwnerInDetails={setSelectedOwnerInDetails}
                            setLandAcquisitionData={setLandAcquisitionData}
                            setLandAcquisition={setLandAcquisition}
                            // onClose={handleCloseAddOwner} // Add this prop
                            onClose={handleCancel}
                            onNavigateToView={(landAcquisitionId) => {
                                setSubComponent('ViewMeasurementList', landAcquisitionId);
                            }}
                            prefillData={{
                                aadhaar_number: '123456789012',
                                pan_number: 'ABCDE1234F'
                            }}
                        />

                    )}

                    {/* Edit Owner Modal */}
                    {showEditOwner && (
                        <EditOwner
                            landAcquisitionId={landAcquisitionId}
                            onAdd={handleOwnerEdited}
                            editFormData={editFormData}
                            setEditFormData={setEditFormData}
                            onCancel={() => setShowEditOwner(false)}
                            onRefresh={refreshMeasurementData}
                            // landAcquisition={landAcquisitionData}
                            landAcquisition={landAcquisition}
                            apiService={apiService}
                            setShowEditOwner={setShowEditOwner}
                            setOwnersData={setOwnersData}
                            setOwners={setOwners}
                            setSelectedOwnerInDetails={setSelectedOwnerInDetails}
                            setLandAcquisitionData={setLandAcquisitionData}
                            setLandAcquisition={setLandAcquisition}
                            // onClose={handleCloseEditOwner} // Add this prop
                            onClose={handleCancelEdit}
                            onNavigateToView={(landAcquisitionId) => {
                                setSubComponent('ViewMeasurementList', landAcquisitionId);
                            }}
                            prefillData={{
                                aadhaar_number: '123456789012',
                                pan_number: 'ABCDE1234F'
                            }}
                        />
                    )}
                </div>

            </div>

            {/* Confirmation Dialog */}
            {showconfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">{translations[language]?.confirmDownload}</h3>
                        <p className="text-gray-600 mb-6">{translations[language]?.confirmDownloadMessage}</p>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded-lg transition-colors"
                            >
                                {translations[language]?.cancel}
                            </button>
                            <button
                                onClick={handleDownloadPDF}
                                className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors"
                            >
                                {translations[language]?.download}
                            </button>
                        </div>
                    </div>
                </div>

            )}

            {/* Simple Alert Notification */}
            {showAlertModal && (
                <div className="fixed top-4 right-4 z-50">
                    <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                        alertConfig.type === 'warning' ? 'border-yellow-500' :
                            alertConfig.type === 'info' ? 'border-blue-500' :
                                'border-green-500'
                        }`}>
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                    alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                        alertConfig.type === 'info' ? 'bg-blue-100' :
                                            'bg-green-100'
                                    }`}>
                                    <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                        alertConfig.type === 'warning' ? 'text-yellow-600' :
                                            alertConfig.type === 'info' ? 'text-blue-600' :
                                                'text-green-600'
                                        }`}>
                                        {alertConfig.type === 'error' ? '✕' :
                                            alertConfig.type === 'warning' ? '⚠' :
                                                alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                    </span>
                                </div>
                            </div>
                            <div className="ml-3 flex-1">
                                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                            </div>
                            <button
                                onClick={() => setShowAlertModal(false)}
                                className="ml-4 text-gray-400 hover:text-gray-600"
                            >
                                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Simple Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewMeasurementList;